import moment from 'moment'

export function getDateWithFormat(date) {
    let date1 = date
    if (date) {
        date1 = date.replace('T', ' ')
        date1 = date1.replace('Z', '')
    }

    return date1
}

export const getConvertTime = (date, time) => {
    const cDate = moment(date).format('YYYY-MM-DD')

    const ctime = moment(time).format('HH:mm:ss')

    return `${cDate} ${ctime}`
}

export function getFormatDateWithTime(data) {
    let date1 = null;
    date1 = moment(data).set('hours', 5).set('minutes', 30).format('YYYY-MM-DD HH:mm:ss');
    return date1;
  }